import React, { memo, useContext, useMemo } from "react";
import IconBreadcrumbs from "../MigasDePan/MigasDePan";

import { withRouter } from "react-router";
import { makeStyles } from "@mui/styles";
import { Box, Chip, IconButton, TextField } from "@mui/material";
import { Backspace, FindInPage } from "@mui/icons-material";
import Botones from "../Botones";
import AlertaContext from "../../../Context/Alerta/AlertaContext";
const useStyles = makeStyles((theme) => ({
  button: {
    [theme.breakpoints.down("md")]: {
      padding: "5px",
      margin: "2px",
      width: "100%",
    },
    fontWeight: "bold",
    margin: theme.spacing(1),
  },
  margin: {
    [theme.breakpoints.down("md")]: {
      padding: "0",
      margin: "2px",
      width: "100%",
    },
    margin: theme.spacing(1),
    width: "60%",
  },
}));
const BarraTablas = (props) => {
  const classes = useStyles();

  const {
    search,
    setsearch,
    funcion,
    buscando,
    LabelBuscador,
    funcionDefault,
    ocultarMigasDePan,
    botones,
    fullBuscador = {},
    columns = [],
  } = props;
  // const { usuario } = useContext(AuthContext);

  const { mostrarAlerta } = useContext(AlertaContext);
  const handleSubmit = (e) => {
    e.preventDefault();

    if (search.trim() === "") {
      return mostrarAlerta("ingrese una busqueda", "error");
    }

    funcion();
  };
  const chips = useMemo(() => {
    return columns
      .map((column) => {
        // Revisar si la propiedad tiene un valor en fullBuscador
        const value1 = fullBuscador[`${column.propiedad}1`];
        const value2 = fullBuscador[`${column.propiedad}2`];
        const value3 = fullBuscador[`${column.propiedad}`];

        // Crear chips solo si hay valores
        const chipsArray = [];
        if (value1) {
          chipsArray.push(
            <Chip
              key={`${column.id}-1`}
              label={`${column.label}-1: ${value1}`}
              color="primary"
              style={{ margin: "4px" }}
            />
          );
        }
        if (value2) {
          chipsArray.push(
            <Chip
              key={`${column.id}-2`}
              label={`${column.label}-2: ${value2}`}
              color="secondary"
              style={{ margin: "4px" }}
            />
          );
        }
        if (value3 && value3.length > 0) {
          chipsArray.push(
            <Chip
              key={`${column.id}`}
              label={`${column.label}: ${value3}`}
              color="secondary"
              style={{ margin: "4px" }}
            />
          );
        }
        return chipsArray;
      })
      .flat(); // Aplanar el array de chips
  }, [fullBuscador, columns]);

  return (
    <div>
      {ocultarMigasDePan ? null : <IconBreadcrumbs />}
      <Box
        display="flex"
        justifyContent="space-between"
        width="100%"
        alignItems="center"
        flexWrap="wrap"
        flexGrow="1"
      >
        <Box
          display="flex"
          justifyContent="flex-start"
          flexWrap="wrap"
          flexGrow="1"
        >
          <Botones botones={botones} />
          {chips}
        </Box>
        <form onSubmit={handleSubmit} className={classes.margin}>
          <TextField
            size="small"
            label={LabelBuscador ? LabelBuscador : "Buscar"}
            variant="outlined"
            fullWidth
            color="primary"
            value={search}
            onChange={(e) => setsearch(e.target.value)}
            InputProps={{
              endAdornment: (
                <Box display="flex" justifyContent="space-between">
                  {buscando ? (
                    <IconButton
                      aria-label=""
                      color="secondary"
                      onClick={async () => {
                        await funcionDefault();
                      }}
                    >
                      <Backspace color="error" />
                    </IconButton>
                  ) : null}
                  <IconButton aria-label="" color="secondary" type="submit">
                    <FindInPage />
                  </IconButton>
                </Box>
              ),
              labelWidth: "600",
            }}
          />
        </form>
      </Box>
    </div>
  );
};

export default withRouter(memo(BarraTablas));
